import React from "react";
import { Field } from "formik";
import { Col } from "reactstrap";
import moment from "moment";
import { withError } from "../../../../../components/hocs";
import {
  Input,
  LabeledDatePicker,
  Select,
} from "../../../../../components/formik";
import { optionsType } from "../../../../../prop-types";
import ReactTooltip from "react-tooltip";
import { useSelector } from "react-redux";
import {   organizationInfoSelector } from "../../../../organization/selectors";
const ErrorInput = withError(Input);

const LegalEntityFormFields = ({ nationalities, percentageOptions }) => {
  const organizationInfo = useSelector(organizationInfoSelector);

  return (
    <React.Fragment>
      <Col lg={3}>
        <Field
          className="mb-3"
          type="text"
          name="fullName"
          placeholder="Company Name"
          component={ErrorInput}
        />
      </Col>
      <Col lg={3}>
        <LabeledDatePicker
          dateFormat="dd.MM.yyyy"
          label=""
          name="birthDate"
          placeholderText="Date of Est."
          minDate={new Date(1900, 0, 1)}
          maxDate={new Date(moment())}
          yearDropdownItemNumber={150}
        />
      </Col>
      <Col lg={3} className="dropdown-group">
        <Field
          isClearable
          type="text"
          name="nationalityId"
          placeholder="Nationality"
          className="dropdown-group"
          component={Select}
          options={nationalities}
        />
      </Col>
      <Col lg={3}>
        <Field
          name="minimumMatchingPercentage"
          placeholder={
            <a
              data-tip={`PEP Match Percent: ${organizationInfo.fuzzyMatchPercentPEP}% <br /> Negative Info List Percent: ${organizationInfo.fuzzyMatchPercentNoPEP}%`}
            >
              Matching Percentage
            </a>
          }
          className="dropdown-group"
          isClearable
          component={Select}
          options={percentageOptions}
        />
        <ReactTooltip place="top" multiline={true} type="info" effect="solid" />
      </Col>
    </React.Fragment>
  );
};
LegalEntityFormFields.propTypes = {
  nationalities: optionsType.isRequired,
};
export default LegalEntityFormFields;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-entries-form/legal-entity-form-fields/LegalEntityFormFields.jsx